export var PerformanceRoutes = {
    "/performance": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.performance",
        "type": "frontend",
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Livewire"
            }
        ],
        "route_dependencies": [
            {path: "d3", type: "library", "name": "d3"},
            {path: "c3", type: "library", "name": "c3"},
            {
                type: 'chunk',
                loader: function () {
                    return import("./performance.module.js");
                }
            }
        ],
        "views": {
            "body": {
                component: "performanceComponent"
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['performance']
        },
        "onEnter": ['$q', 'hUser', '$state', 'brandServices', 'TeamScheduleService', 'userPermissions',
            function ($q, hUser, $state, brandServices, TeamScheduleService, userPermissions) {
            $('body').addClass('schedule-body');
                TeamScheduleService.getActiveBrand()
                    .then(function (brand) {
                        var promises = {
                            'policyParser': userPermissions.getBrandPolicy(brand.id),
                            'isLPMEnabled': brandServices.check(brandServices.SERVICES.POS, brand.id, true)
                        };

                        $q.all(promises)
                            .then(function (result) {
                                var hasLiveWirePermission = result.policyParser.has(userPermissions.PERMISSIONS.VIEW_LIVE_WIRE_AND_HARRI_LIVE_DASHBOARDS);
                                var isLPMEnabled = result.isLPMEnabled;

                                if (!isLPMEnabled || !hUser.hasSalesAccess() || !hasLiveWirePermission) {
                                    $state.go('appLayout.schedule.team');
                                }
                            })
                            .catch(function (err) {
                                console.error(err);
                            });
                    });
            }]
    },
};